<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Edit Location"
    icon="edit"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="Location Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlAutoComplete
              :items="enabledClientList"
              v-model="clientId"
              item-text="name"
              item-value="id"
              label="Owner*"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="isEnabled"
              label="Enabled?"
              :disabled="isLoading"
            />
          </v-flex>
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlCheckbox from '../../../common/components/controls/ControlCheckbox'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlCheckbox,
    ControlAutoComplete,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    locationToEdit: {
      type: Object,
      required: true,
    },
    clientList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    id: null,
    name: null,
    clientId: null,
    isEnabled: null,
  }),
  computed: {
    enabledClientList() {
      return this.clientList.filter((client) => client.isEnabled)
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog && this.locationToEdit.id) {
        this.id = this.locationToEdit.id
        this.name = this.locationToEdit.name
        this.clientId = this.locationToEdit.clientIdOwner
        this.isEnabled = this.locationToEdit.isEnabled
      }
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        id: this.id,
        name: this.name,
        clientId: this.clientId,
        isEnabled: this.isEnabled,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.id = null
      this.name = null
      this.clientId = null
      this.isEnabled = null
    },
  },
}
</script>